"use client";

import { Button, Input, Label } from "@devhop/ui";
import { PackageIcon } from "lucide-react";
import { useState } from "react";

export function WorkshopCustomerSuppliedPartForm({
  onAdd,
  disabled,
}: {
  onAdd: (args: { name: string; qty: number }) => void | Promise<void>;
  disabled?: boolean;
}) {
  const [name, setName] = useState("");
  const [qty, setQty] = useState("1");

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    const trimmed = name.trim();
    if (!trimmed) return;
    const n = Number.parseInt(qty, 10);
    if (!Number.isFinite(n) || n < 1) return;
    await onAdd({ name: trimmed, qty: n });
    setName("");
    setQty("1");
  }

  return (
    <form
      onSubmit={(e) => void submit(e)}
      className="space-y-2 rounded-lg border border-violet-200 bg-violet-50/60 p-3"
    >
      <p className="flex items-center gap-1.5 font-medium text-sm text-violet-950">
        <PackageIcon className="size-4" />
        ລູກຄ້ານຳອາໄຫຼ່ມາເອງ
      </p>
      <p className="text-violet-900/80 text-xs leading-relaxed">
        ບັນທຶກຊື່ອາໄຫຼ່ທີ່ລູກຄ້ານຳມາ — ບໍ່ຫັກຄ່າອາໄຫຼ່ (ຄິດແຕ່ຄ່າແຮງ)
      </p>
      <div className="space-y-1.5">
        <Label htmlFor="cs-part-name" className="text-xs">
          ຊື່ອາໄຫຼ່
        </Label>
        <Input
          id="cs-part-name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="ເຊັ່ນ: ແບັດເຕີຣີ້ GS ເກົ່າ"
          disabled={disabled}
          className="h-10 bg-background"
        />
      </div>
      <div className="flex flex-wrap items-end gap-2">
        <div className="w-24 space-y-1.5">
          <Label htmlFor="cs-part-qty" className="text-xs">
            ຈຳນວນ
          </Label>
          <Input
            id="cs-part-qty"
            inputMode="numeric"
            value={qty}
            onChange={(e) => setQty(e.target.value)}
            disabled={disabled}
            className="h-10 bg-background"
          />
        </div>
        <Button
          type="submit"
          size="sm"
          className="h-10"
          disabled={disabled || !name.trim()}
        >
          ເພີ່ມ
        </Button>
      </div>
    </form>
  );
}
